import axios from "axios";


const state = {
    solicitudFacturaSeleccionada: null,
    totalPaginas:null,
    solicitudesFacturas: null,
    totalRegistros: null,
};

const getters = {
    solicitudesFacturas: (state) => state.solicitudesFacturas,
    solicitudFacturaSeleccionada: (state) => state.solicitudFacturaSeleccionada,
    totalPaginas: (state) => state.totalPaginas,
};

const mutations = {
    setSolicitudesFacturas: (state, solicitudesFacturas) => {
        state.solicitudesFacturas = solicitudesFacturas;
    },
    setSolicitudFacturaSeleccionada: (state, solicitudFacturaSeleccionada) => {
        state.solicitudFacturaSeleccionada = solicitudFacturaSeleccionada;
    },

    setTotalPaginas: (state, data) => {
        state.totalPaginas = data;
    },
    setTotalRegistros: (state, data) => {
        state.totalRegistros = data;
    },
    inicializar: (state) => {
        (state.solicitudesFacturas = null), (state.solicitudesFacturas = null);
    },
};

const actions = {

    async consultarSolicitudesXPagina({commit}, data) {
        try {
            let res = await axios.get(`/v1/solicitudes-facturas/${data.pagina}/pagina`);
            commit("setSolicitudesFacturas", res?.data?.result);
        } catch (error) {
            return error;
        }
    },
    async consultarTotalPaginas({commit}) {
        try {
            const resp = await axios.get(`/v1/solicitudes-facturas/total`);
            commit("setTotalPaginas", resp?.data?.totalPaginas);
            return resp?.data?.totalPaginas || 0;
        } catch (error) {
            return error;
        }
    },


    async consultarSolicitudesFacturasXFiltros({commit}, data) {
        try {
            let resp = await axios.post(`/v1/solicitudes-facturas/filtros`, data);
            commit("setSolicitudesFacturas", resp?.data?.result?.facturas);
            commit("setTotalPaginas", resp?.data?.result?.paginacion?.totalPaginas || 1);
            commit("setTotalRegistros", resp?.data?.result?.paginacion?.totalRegistros || 0);
        } catch (error) {
            return error;
        }
    },

    async reenviar(_, data) {
        try {
            let resp = await axios.get(`/v1/solicitudes-facturas/${data}/reenviar`);
            return {
                success: true,
                data: resp.data,
            }
        } catch (error) {
            return {
                success: false,
                data: error.response.data.errors
            }
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
